

















































export default
  name: 'inside'
  components: `{
    hm_widgets:     require('./widgets.vue').default,
    hm_menu:        require('./menu.vue').default,
    demo_bar:       () => import(/* webpackChunkName: "demo_bar" */'./demo_bar.vue'),
    payment_bar:    require('./payment_bar.vue').default,
    about_hm_modal: require('./onboarding/about_hm_modal.vue').default,
    offline_bar:    require('./offline_bar.vue').default,
    hm_footer:      require('components/guest/footer.vue').default,
    ios_prompt: () => import(/* webpackChunkName: "ios_prompt" */'components/mobile/ios_prompt.vue'),
    transactions_preview: () => import(/* webpackChunkName: "transactions_preview" */'components/inside/transactions_preview.vue'),
    transaction_current_popover: () => import(/* webpackChunkName: "current_popover" */'components/inside/elements/transactions/current_popover.vue'),
  }`
  computed:
    docs_url: -> "#{HM.promo_site_url}/#{HM.locale}/docs"
  beforeCreate: -> @$store.dispatch 'loginUserFromLocalStorage'
  methods:
    showTooltips: -> @$store.dispatch 'showAllTooltips'
    hideTooltips: -> @$store.dispatch 'hideAllTooltips'
